import { render, staticRenderFns } from "./editPlatformCoupon.vue?vue&type=template&id=2ba70d0a"
import script from "./editPlatformCoupon.vue?vue&type=script&lang=js"
export * from "./editPlatformCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports